import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-save-team-dialog',
    templateUrl: './save-team-dialog.component.html',
    styleUrls: ['./save-team-dialog.component.scss'],
    standalone: false ,  // NOSONAR
})
export class SaveTeamDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { // NOSONAR
		//  do something 
	}

}
